export default __webpack_public_path__ + "static/media/CEDIA-pescando.862c3e64.jpeg";